import clsx from 'clsx';
import { formatIQD } from '../../../shared/format.js';
import { usePosState } from '../hooks/usePosState.js';


// نقاط البيع (الكافتريا/الألعاب) لا تقبل دفعاً نقدياً مباشراً ولا بيعاً خارجياً.
// الدفع حصرياً عبر رصيد الكارت أو تعليق على جلسة الطفل، والتسوية تتم عبر الكاشير الرئيسي.
const ALL_METHODS = [
  { key: 'card_balance', label: 'رصيد الكارت' },
  { key: 'on_session', label: 'تعليق على الكارت' }
];

export function PaymentPanel({ grandTotal }) {
  const link = usePosState((s) => s.link);
  const payment = usePosState((s) => s.payment);
  const setPayment = usePosState((s) => s.setPayment);

  const cardBalance = link?.cardBalance ?? null;

  // «رصيد الكارت» يظهر متى وُجد كارت — حتى لو كان الرصيد غير كافٍ، كي تظهر
  // رسالة صريحة بالرصيد والمطلوب بدل اختفاء الخيار بلا سبب مفهوم.
  const hasCard = !!link?.cardUid;
  const insufficient = hasCard && cardBalance != null && cardBalance < grandTotal;
  const methods = ALL_METHODS.filter((m) => {
    if (m.key === 'on_session') return !!link?.sessionId;
    if (m.key === 'card_balance') return hasCard;
    return true;
  });

  return (
    <div className="space-y-2.5">
      <div>
        <div className="text-[11px] font-semibold text-ink-2 mb-1">طريقة الدفع</div>
        <div className="grid grid-cols-2 gap-1.5">
          {methods.map((m) => (
            <button
              key={m.key}
              type="button"
              onClick={() => setPayment({ method: m.key, paidAmount: 0 })}
              className={clsx(
                'btn justify-center text-[12.5px]',
                payment.method === m.key && 'btn-primary'
              )}
            >
              {m.label}
            </button>
          ))}
        </div>
        {methods.length === 0 ? (
          <div className="bg-paper-2 rounded-[10px] p-2.5 text-[11.5px] text-ink-3">
            اربط الكارت أو ابحث عن جلسة طفل لاختيار طريقة الدفع.
          </div>
        ) : null}
      </div>

      {payment.method === 'on_session' ? (
        <div className="bg-[#FFF6EB] border border-orange/30 rounded-[10px] p-2.5 text-[11.5px] text-ink-2">
          سيتم تعليق المبلغ على جلسة الطفل ودفعه عند الخروج.
        </div>
      ) : null}
      {payment.method === 'card_balance' ? (
        insufficient ? (
          <div className="bg-[#FEE2E2] border border-[#FCA5A5] text-[#B91C1C] rounded-[10px] p-2.5 text-[11.5px] font-semibold">
            رصيد البطاقة غير كافٍ لإتمام عملية الشراء — المتوفر {formatIQD(cardBalance || 0)} والمطلوب {formatIQD(grandTotal)}.
          </div>
        ) : (
          <div className="bg-[#CFFAFE] text-[#0E7490] rounded-[10px] p-2.5 text-[11.5px]">
            سيُخصم {formatIQD(grandTotal)} من رصيد الكارت ({formatIQD(cardBalance || 0)}).
          </div>
        )
      ) : null}
      {link?.subscriptionOnly && link?.cardMissing ? (
        <div className="bg-[#FEF3C7] border border-[#FCD34D] text-[#92400E] rounded-[10px] p-2.5 text-[11.5px]">
          لا توجد بطاقة مرتبطة بهذا الطفل — لا يمكن الدفع من الرصيد. اربط له بطاقة أو سجّل دخوله ليُعلَّق المبلغ على جلسته.
        </div>
      ) : null}
    </div>
  );
}
